import EmailTemplatesActions from '../actions/EmailTemplatesActions';
import { EmailTemplates } from '../interfaces/emailTemplates';
import { setBusy, setUnBusy } from './common/commonReducers';

const initialState: EmailTemplates = {
  busy: false,
  entities: [],
  pagination: {
    total: 0,
    page: 0,
    perPage: 25,
    totalPages: 0,
    isLastPage: false,
  },
};

export default function emailTemplates(
  state = initialState,
  action,
): EmailTemplates {
  switch (action.type) {
    case EmailTemplatesActions.busyAction:
      return setBusy(state);
    case EmailTemplatesActions.retrievedAllAction: {
      const { templates, pagination } = action.entities;
      return {
        ...state,
        busy: false,
        entities: templates,
        pagination,
      };
    }
    case EmailTemplatesActions.unbusyAction:
      return setUnBusy(state);
    default:
      return state;
  }
}
